<template>
  <div class="homePage">
    <div class="homePage-title">{{ $t("module.exchange.title1") }}</div>

    <div class="lable-box">
      <div @click="actvie = 1" :class="['lable', { actvie: actvie === 1 }]">
        {{ $t("module.exchange.title2") }}
        <img class="hot" src="@/assets/image/module/hot.png" />
      </div>
      <div @click="actvie = 2" :class="['lable', { actvie: actvie === 2 }]">
        {{ $t("module.exchange.title3") }}
      </div>
      <div @click="actvie = 3" :class="['lable', { actvie: actvie === 3 }]">
        {{ $t("module.exchange.title4") }}
      </div>
    </div>

    <div class="content-box" v-if="actvie === 1">
      <div class="content-item" v-for="(item, index) in list1" :key="index">
        <img class="img1" :src="item.thumbImageUrl" @error="handleError" />

        <div class="name">{{ item.name }}</div>
        <div class="tips">
          ( {{ $t("module.exchange.title6") }}{{ item.stock
          }}{{ $t("module.exchange.title7") }})
        </div>
        <div class="gold">
          <div class="number">{{ item.displayPoints }}</div>
          <div class="text">{{ $t("module.exchange.title5") }}</div>
        </div>

        <div class="zhezhao">
          <div
            :class="`${flag ? 'lj lj-active' : 'lj'}`"
            @click="exchange(item)"
          >
            {{ $t("module.exchange.title8") }}
          </div>
          <div class="tip" v-html="item.describe"></div>
        </div>
      </div>
      <div class="empty-box" v-if="list1.length === 0">
        <el-empty :description="$t('module.exchange.title10')"></el-empty>
      </div>
    </div>

    <div class="pagination-box" v-if="actvie === 1">
      <el-pagination
        @size-change="getGifts(1)"
        @current-change="getGifts"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size.sync="size"
        layout="total, sizes, prev, pager, next"
        :total="total"
      >
      </el-pagination>
    </div>

    <div class="content-box" v-if="actvie === 2">
      <div class="content-item" v-for="(item, index) in list2" :key="index">
        <img
          class="img2"
          v-if="item.type === 1"
          src="@/assets/image/module/eicon2-2.png"
        />
        <img class="img2" v-else src="@/assets/image/module/eicon2-1.png" />
        <div class="name" v-if="item.type === 1">
          {{ $t("module.exchange.title11") }}
        </div>
        <div class="name" v-else>{{ $t("module.exchange.title12") }}</div>
        <div class="tips">
          ({{ $t("module.exchange.title6") }}10{{
            $t("module.exchange.title7")
          }})
        </div>
        <div class="gold">
          <div class="number">1000</div>
          <div class="text">{{ $t("module.exchange.title5") }}</div>
        </div>

        <div class="zhezhao">
          <div class="lj">{{ $t("module.exchange.title8") }}</div>
          <div class="tip">{{ $t("module.exchange.title9") }}</div>
        </div>
      </div>

      <div class="empty-box" v-if="list2.length === 0">
        <el-empty :description="$t('module.exchange.title10')"></el-empty>
      </div>
    </div>

    <div class="content-box" v-if="actvie === 3">
      <div class="content-item" v-for="(item, index) in list3" :key="index">
        <img
          class="img3"
          v-if="item.type === 1"
          src="@/assets/image/module/eicon3-2.png"
        />
        <img class="img3" v-else src="@/assets/image/module/eicon3-1.png" />
        <div class="name" v-if="item.type === 1">
          {{ $t("module.exchange.title11") }}
        </div>
        <div class="name" v-else>{{ $t("module.exchange.title12") }}</div>
        <div class="tips">
          ({{ $t("module.exchange.title6") }}10{{
            $t("module.exchange.title7")
          }})
        </div>
        <div class="gold">
          <div class="number">1000</div>
          <div class="text">{{ $t("module.exchange.title5") }}</div>
        </div>

        <div class="zhezhao">
          <div class="lj">{{ $t("module.exchange.title8") }}</div>
          <div class="tip">{{ $t("module.exchange.title9") }}</div>
        </div>
      </div>
      <div class="empty-box" v-if="list3.length === 0">
        <el-empty :description="$t('module.exchange.title10')"></el-empty>
      </div>
    </div>

    <div class="content-box2" v-if="actvie === 1">
      <div
        class="content-item"
        v-for="(item, index) in list1"
        @click="chageShow(index)"
        :key="index"
      >
        <img class="img1" :src="item.thumbImageUrl" />

        <div class="name">{{ item.name }}</div>
        <div class="tips">
          ( {{ $t("module.exchange.title6") }}{{ item.stock
          }}{{ $t("module.exchange.title7") }})
        </div>
        <div class="gold">
          <div class="number">{{ item.displayPoints }}</div>
          <div class="text">{{ $t("module.exchange.title5") }}</div>
        </div>

        <div :class="`zhezhao ${item.show ? 'zhezhao-top' : ''}`">
          <div class="lj" @click="exchange(item)">
            {{ $t("module.exchange.title8") }}
          </div>
          <div class="tip" v-html="item.describe"></div>
        </div>
      </div>
      <div class="empty-box" v-if="list1.length === 0">
        <el-empty :description="$t('module.exchange.title10')"></el-empty>
      </div>
    </div>

    <div class="content-box2" v-if="actvie === 2">
      <div class="content-item" v-for="(item, index) in list2" :key="index">
        <img
          class="img2"
          v-if="item.type === 1"
          src="@/assets/image/module/eicon2-2.png"
        />
        <img class="img2" v-else src="@/assets/image/module/eicon2-1.png" />
        <div class="name" v-if="item.type === 1">
          {{ $t("module.exchange.title11") }}
        </div>
        <div class="name" v-else>{{ $t("module.exchange.title12") }}</div>
        <div class="tips">
          ({{ $t("module.exchange.title6") }}10{{
            $t("module.exchange.title7")
          }})
        </div>
        <div class="gold">
          <div class="number">1000</div>
          <div class="text">{{ $t("module.exchange.title5") }}</div>
        </div>

        <div class="zhezhao">
          <div class="lj">{{ $t("module.exchange.title8") }}</div>
          <div class="tip">{{ $t("module.exchange.title9") }}</div>
        </div>
      </div>

      <div class="empty-box" v-if="list2.length === 0">
        <el-empty :description="$t('module.exchange.title10')"></el-empty>
      </div>
    </div>

    <div class="content-box2" v-if="actvie === 3">
      <div class="content-item" v-for="(item, index) in list3" :key="index">
        <img
          class="img3"
          v-if="item.type === 1"
          src="@/assets/image/module/eicon3-2.png"
        />
        <img class="img3" v-else src="@/assets/image/module/eicon3-1.png" />
        <div class="name" v-if="item.type === 1">
          {{ $t("module.exchange.title11") }}
        </div>
        <div class="name" v-else>{{ $t("module.exchange.title12") }}</div>
        <div class="tips">
          ({{ $t("module.exchange.title6") }}10{{
            $t("module.exchange.title7")
          }})
        </div>
        <div class="gold">
          <div class="number">1000</div>
          <div class="text">{{ $t("module.exchange.title5") }}</div>
        </div>

        <div class="zhezhao">
          <div class="lj">{{ $t("module.exchange.title8") }}</div>
          <div class="tip">{{ $t("module.exchange.title9") }}</div>
        </div>
      </div>
      <div class="empty-box" v-if="list3.length === 0">
        <el-empty :description="$t('module.exchange.title10')"></el-empty>
      </div>
    </div>

    <MobileTips
      v-if="isTips"
      @close="close"
      @changeAccepted="changeCashoutDialogVisible"
    ></MobileTips>

    <el-dialog
      :title="$t('module.exchange.title13')"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <div class="dialog-herder">
        <div class="title">{{ $t("module.exchange.title14") }}</div>
        <div class="tips" v-if="alipay">
          {{ $t("module.exchange.title15") }}{{ alipay | phoneFrom }}
        </div>
        <div class="tips" v-else>{{ $t("module.exchange.title16") }}</div>
        <div class="tips">
          {{ $t("module.exchange.title17")
          }}{{ name ? name : $t("module.exchange.title18") }}
        </div>
      </div>

      <div class="dialog-footer">
        <div></div>
        <div class="right">
          <div class="cancel" @click="handleClose">
            {{ $t("module.exchange.title19") }}
          </div>
          <div class="cancel" @click="goUrl('/module/account')">
            {{ $t("module.exchange.title20") }}
          </div>
          <div class="submit" @click="setOrder">
            {{ $t("module.exchange.title21") }}
          </div>
        </div>
      </div>
    </el-dialog>

    <MobileExchangeMethod
      v-if="isMobileExchangeMethod"
      @close="isMobileExchangeMethod = false"
      :url="url"
      :name="options.name"
    ></MobileExchangeMethod>

    <ManualReview
      v-if="isManualReview"
      @submit="submit"
      :isMobule="true"
    ></ManualReview>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import { getGifts, setOrder, getAlipay, getAccount } from "@/api/user";
import MobileTips from "@/components/mobileTips";
import MobileExchangeMethod from "@/components/mobileExchangeMethod";
import ManualReview from "@/components/manualReview";
export default {
  filters: {
    phoneFrom(phone) {
      return phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  data() {
    return {
      menuTop: 86,
      percentage: 0,
      grade: 1,
      credit: 295,
      behindNumer: 800,
      actvie: 1,
      list1: [],
      list2: [],
      list3: [],

      isTips: false,

      userInfo: {},

      options: {},

      alipay: null,
      name: null,

      dialogVisible: false,
      url: "111",
      isMobileExchangeMethod: false,
      isManualReview: false,

      page: 1,
      size: 10,
      total: 0,

      flag: false,
    };
  },
  components: { Navigation, MobileTips, MobileExchangeMethod, ManualReview },
  methods: {
    //获取支付宝信息
    async getAlipay() {
      await getAlipay().then((res) => {
        if (res.code === 200) {
          this.alipay = res.data.alipay;
          this.name = res.data.name;
        }
      });
    },
    handleError(e) {
      console.log("触发");
      e.target.src = process.env.VUE_APP_SERVER + "/images/gift/default.png";
      e.target.onerror = null; // 防止闪图/死循环
    },
    handleClose() {
      this.flag = false;
      this.dialogVisible = false;
    },
    goUrl(path) {
      this.$router.push(path);
    },
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },

    submit() {
      this.isManualReview = false;
      this.$router.push("/module/redemptionHistory");
    },

    chageShow(index) {
      this.list1[index].show = true;
      this.list1 = this.list1.concat([]);
      console.log(this.list1[index].show);
    },

    async exchange(data) {
      if (this.flag) {
        return;
      }
      this.flag = true;
      if (data) {
        this.options = data;
      }
      if (this.userInfo.cashoutDialogVisible) {
        this.isTips = true;
        return;
      }

      if (!this.options.stock) {
        this.$message.warning(this.$t("module.exchange.title22"));
        return;
      }

      if (localStorage.getItem("userInfo")) {
        this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
        this.$store.commit("changeUserInfo", this.userInfo);
      } else {
        await getAccount()
          .then((res) => {
            if (res.code === 200) {
              this.userInfo = res.data;
              this.$store.commit("changeUserInfo", this.userInfo);
              localStorage.setItem("userInfo", JSON.stringify(res.data));
            }
            console.log(res);
          })
          .catch((err) => {
            console.log(err.response.status);
            if (err.response.status === 401) {
              this.$message.error("兑换前,请先登录");
              this.$router.push("/login");
            }
          });
      }

      //微信红包
      if (this.options.categoryId === 2) {
        setOrder({
          id: this.options.id,
        })
          .then((res) => {
            this.flag = false;
            if (res.code === 200) {
              if (this.userInfo.credit >= 100) {
                this.url = res.data.thumbImageUrl;
                this.isMobileExchangeMethod = true;
              } else {
                this.isManualReview = true;
              }
            }
          })
          .catch((err) => {
            if (err.response.status === 401) {
              this.$message.error(err.response.data.msg);
              this.$router.push("/login");
            }
          });
        return;
      } else if (this.options.categoryId === 1) {
        // 支付宝
        await this.getAlipay();
        this.dialogVisible = true;
      } else {
        this.setOrder();
      }
    },

    setOrder() {
      setOrder({
        id: this.options.id,
      })
        .then((res) => {
          this.flag = false;
          if (res.code === 200) {
            this.$message.success(this.$t("module.exchange.title23"));
            this.handleClose();
          }
        })
        .catch((err) => {
          if (err.response.status === 401) {
            this.$message.error(err.response.data.msg);
            this.$router.push("/login");
          }
        });
    },

    close() {
      this.isTips = false;
    },

    changeCashoutDialogVisible() {
      this.flag = false;
      this.userInfo.cashoutDialogVisible = false;
      this.exchange();
    },

    async getGifts(type) {
      if (type) {
        this.page = type;
      }
      await getGifts({
        page: this.page,
        size: this.size,
      }).then((res) => {
        if (res.code === 200) {
          this.list1 = res.data.list;
          this.total = res.data.dataCount;
          this.list1.forEach((_, index, array) => {
            array[index].show = false;
          });
        }
      });
    },
  },
  async created() {
    await this.getGifts();
  },
  mounted() {},
  destroyed() {},
};
</script>
<style scoped>
.circle >>> svg > path:nth-child(2) {
  stroke: url(#write);
}
.circle >>> .el-progress__text {
  display: none;
}
.progress >>> .el-progress-bar__inner {
  background: linear-gradient(90deg, #ffa200 0%, #ff6c00 100%);
}
.pagination-box {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  margin-right: 25px;
  padding-bottom: 15px;
}
</style>
<style lang="scss" scoped>
.homePage {
  width: 100%;
  padding: 0 140px;
  box-sizing: border-box;
  background-color: #fff;
  min-height: 500px;
  .homePage-title {
    font-size: 24px;
    color: #474f66;
    font-weight: bolder;
    padding: 36px 0 30px 0;
  }
  .lable-box {
    display: flex;
    border-bottom: 1px solid #ededed;
    .lable {
      position: relative;
      color: #474f66;
      font-size: 16px;
      margin-right: 36px;
      font-weight: bolder;
      height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      // padding-right: 16px;
      .hot {
        position: absolute;
        width: 16px;
        height: 16px;
        right: -16px;
      }
    }
    .actvie {
      font-size: 22px;
      color: #8948ff;
    }
    .actvie::before {
      content: "";
      position: absolute;
      width: 16px;
      height: 3px;
      background-color: #8948ff;
      z-index: 22;
      bottom: -2px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .content-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 35px;
    .content-item {
      position: relative;
      width: calc((100% - 80px) / 6);
      margin-right: 16px;
      height: 250px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      margin-bottom: 17px;
      cursor: pointer;
      overflow: hidden;
      .img1 {
        max-width: 100px;
        height: auto;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 20px;
      }
      .img2 {
        width: 100px;
        height: 100px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 20px;
      }
      .img3 {
        width: 120px;
        height: 105px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 20px;
      }
      .name {
        font-size: 14px;
        color: #232323;
        text-align: center;
        margin-top: 10px;
      }
      .tips {
        text-align: center;
        color: #999999;
        font-size: 12px;
        margin-top: 2px;
      }
      .gold {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: 10px;
        color: #ff3636;
        .number {
          font-size: 28px;
          font-weight: bolder;
        }
        .text {
          font-size: 15px;
          margin-bottom: 5px;
          margin-left: 5px;
        }
      }
      .zhezhao {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #8948ff;
        border-radius: 8px;
        top: 250px;
        left: 0;
        transition: top ease 0.35s;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .lj {
          width: 104px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #ffffff;
          border-radius: 3px;
          font-size: 14px;
          color: #8948ff;
        }
        .lj-active {
          opacity: 0.7;
        }
        .tip {
          font-size: 12px;
          color: #fff;
          margin-top: 15px;
          padding: 0 12px;
          text-align: center;
          max-height: 100px;
          overflow: auto;
        }
      }
    }
    .content-item:hover {
      .zhezhao {
        top: 0;
      }
    }
    .content-item:nth-child(6n) {
      margin-right: 0;
    }
  }
  .content-box2 {
    display: none;
    flex-wrap: wrap;
    margin-top: 35px;
    .content-item {
      position: relative;
      width: calc((100% - 80px) / 6);
      margin-right: 16px;
      height: 250px;
      background: #ffffff;
      box-shadow: 0px 3px 10px 1px rgba(0, 0, 0, 0.1);
      border-radius: 8px;
      margin-bottom: 17px;
      cursor: pointer;
      overflow: hidden;
      .img1 {
        max-width: 100px;
        height: auto;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 20px;
      }
      .img2 {
        width: 100px;
        height: 100px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 20px;
      }
      .img3 {
        width: 120px;
        height: 105px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-top: 20px;
      }
      .name {
        font-size: 14px;
        color: #232323;
        text-align: center;
        margin-top: 10px;
      }
      .tips {
        text-align: center;
        color: #999999;
        font-size: 12px;
        margin-top: 2px;
      }
      .gold {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        margin-top: 10px;
        color: #ff3636;
        .number {
          font-size: 28px;
          font-weight: bolder;
        }
        .text {
          font-size: 15px;
          margin-bottom: 5px;
          margin-left: 5px;
        }
      }
      .zhezhao {
        position: absolute;
        width: 100%;
        height: 100%;
        background-color: #8948ff;
        border-radius: 8px;
        top: 250px;
        left: 0;
        transition: top ease 0.35s;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .lj {
          width: 104px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          background: #ffffff;
          border-radius: 3px;
          font-size: 14px;
          color: #8948ff;
        }
        .tip {
          font-size: 12px;
          color: #fff;
          margin-top: 15px;
          padding: 0 12px;
          text-align: center;
          max-height: 100px;
          overflow: auto;
        }
      }
    }
    .content-item {
      .zhezhao-top {
        top: 0;
      }
    }
    .content-item:nth-child(6n) {
      margin-right: 0;
    }
  }
}

.empty-box {
  width: 100%;
  display: flex;
  justify-content: center;
}

.dialog-herder {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 0 20px;

  .title {
    margin-top: 20px;
    color: #474f66;
    font-size: 14px;
  }
  .tips {
    color: #474f66;
    font-size: 14px;
    margin-top: 5px;
  }
}
.dialog-footer {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 20px 20px 20px;
  display: flex;
  justify-content: space-between;
  .left {
    color: #ff2e26;
    font-size: 12px;
    font-weight: bolder;
  }
  .right {
    display: flex;
  }
  .cancel {
    padding: 0 12px;
    min-height: 32px;
    line-height: 32px;
    background: #f8f8f8;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
    border: 1px solid #eee;
    margin-left: 10px;
  }
  .submit {
    padding: 0 12px;
    min-height: 32px;
    line-height: 32px;
    background: #8948ff;
    border-radius: 4px 4px 4px 4px;
    color: #fff;
    margin-left: 10px;
    cursor: pointer;
    border: 1px solid #8948ff;
  }
}
</style>
<style scoped>
@media only screen and (max-width: 750px) {
  .el-dialog__wrapper >>> .el-dialog {
    width: 90% !important;
  }
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */

@media only screen and (max-width: 1200px) {
  .homePage {
    padding: 0 70px;
  }
}
@media only screen and (max-width: 1050px) {
  .homePage {
    padding: 0 30px;
    .content-box {
      .content-item {
        width: calc((100% - 32px) / 3);
      }
      .content-item:nth-child(6n) {
        margin-right: 16px;
      }
      .content-item:nth-child(3n) {
        margin-right: 0;
      }
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    padding: 0 15px;
    .homePage-title {
      display: none;
    }
    .lable-box {
      background-color: rgba(0, 0, 0, 0);
      padding: 0;
      margin-top: 0;
      border: none;
      min-height: 40px;
      line-height: 40px;
      margin: 15px 0;
      text-align: center;
      .lable {
        margin-right: 31px;
        font-size: 16px;
      }
      .actvie {
        font-size: 22px;
      }
    }
    .content-box {
      display: none;
    }
    .content-box2 {
      display: flex;
      .content-item {
        width: calc((100% - 16px) / 2);
      }
      .content-item:nth-child(6n) {
        margin-right: 16px;
      }
      .content-item:nth-child(3n) {
        margin-right: 16px;
      }
      .content-item:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
}
</style>